<template>
  <div class="text-xs-center">
    <v-container>
      <v-progress-circular
        :width="width"
        :color="color"
        indeterminate
        :size="size"
      ></v-progress-circular>
      <div v-if="message" class="pa-3 primary--text">{{message}}</div>
    </v-container>
  </div>
</template>
<script>
export default {
  name: "AppLoader",
  props: {
      color: {
          type: String,
          default: 'primary'
      },
      width: {
          type: Number,
          default: 3
      },
      size: {
          type: Number,
          default: 50
      },
      message: {
          type: String,
          default: null
      }
  }
};
</script>
